import { jsx as m } from "react/jsx-runtime";
import "@smart/web-foundations";
import "react";
import { Theme as e } from "./theme.js";
import './assets/component-provider.css';const t = ({
  theme: o,
  children: r
}) => /* @__PURE__ */ m(e, { theme: o, children: r });
t.displayName = "ComponentProvider";
export {
  t as ComponentProvider
};
//# sourceMappingURL=component-provider.js.map
